var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"mobileLogo",attrs:{"href":"/"}},[_c('img',{staticClass:"img-fluid ",staticStyle:{"margin-top":"4px","max-height":"50px"},attrs:{"src":"/img/lhm_logo_w.png"},on:{"click":_vm.pushToHome}})])}
var staticRenderFns = []

export { render, staticRenderFns }